import { Link } from "@arctheme-components/elements/Link/Link";
import Paragraph from "@arctheme-components/elements/Paragraph/Paragraph";
import React from "react";
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import {Button} from "@src/stories/elements/Button/Button";
import { useQuoteParser } from "@src/hooks/useQuoteParser";

interface ExpertiseItem {
  title: string;
  url: string;
}

interface ExpertiseBlockProps {
  settings: {
    settings: {
      section: {
        title?: string;
        description?: string;
        quote_text_parts?: string;
        quote_style?: string;
        quote_style_mobile?: string;
        body_style?: string;
        body_style_mobile?: string;
        cta_style_type?: string;
        cta_style?: string;
        cta_text?: string;
        cta_url?: string;
        blocks: Array<{
          type: string;
          settings: {
            title: string;
            url: string;
          };
        }>;
      };
      mobile_breakpoint?: number;
    };
  };
}

export const ExpertiseBlock: React.FC<ExpertiseBlockProps> = ({ settings }) => {
  // Extract all data from settings
  const {
    title,
    description,
    quote_text_parts,
    quote_style,
    quote_style_mobile,
    body_style,
    body_style_mobile,
    cta_style,
    cta_style_type,
    cta_text,
    cta_url,
    block_title,
    block_header_style,
    block_header_style_mobile,
    image
  } = settings.settings.section;

  const isMobile = useMobileBreakpoint(settings.settings.mobile_breakpoint);
  
  // Extract expertise items from blocks
  const expertiseItems: ExpertiseItem[] = settings.settings.blocks
    .filter(block => block.type === "expertise_item")
    .map(block => ({
      title: block.settings.title,
      url: block.settings.url
    }));

  // Use the quote parser hook to handle description formatting
  const renderParsedDescription = useQuoteParser({
    text: description,
    quoteTextParts: quote_text_parts,
    quoteStyle: isMobile ? quote_style_mobile : quote_style,
    bodyStyle: isMobile ? body_style_mobile : body_style
  });

  return (
    <section className="py-12">
      <div className={`flex ${isMobile ? "flex-col gap-y-10" : "flex-row"} gap-8`}>
        
        <div className="flex basis-[60%] lg:p-8">
            {(title || description) && (
            <div className="flex flex-col gap-6">
                {title && <h2 className={`${isMobile ? settings.settings.section.header_style_mobile : settings.settings.section.header_style}`}>{title}</h2>}
                {description && renderParsedDescription()}
            </div>
            )}
        </div>
        <div className="flex flex-col basis-[40%] p-8 bg-[#272726] gap-8 relative rounded-[4px] shadow-[0_12px_16px_-4px_rgba(0,0,0,0.08),0_4px_6px_-2px_rgba(0,0,0,0.03)]">
          <div className="flex items-center justify-between">
            {!isMobile && image && <img className={`absolute top-0 right-0 p-4 w-[110px] h-[110px]`} src={image} alt="Shopify Logo"></img>}
            {block_title && <h2 className={`text-white ${isMobile ? block_header_style_mobile : block_header_style}`}>{block_title}</h2>}
          </div>
            {expertiseItems.length > 0 && (
            <div className="flex flex-wrap gap-4 ">
                {expertiseItems.map((item, index) => (
                <a
                    key={index}
                    href={item.url}
                    className="flex flex-wrap rounded-full b_a1 bg-[#FBF8F4] text-black h-[40px] items-center justify-center px-5"
                >
                    {item.title}
                </a>
                ))}
            </div>
            )}

            {cta_text && (
            <div className="flex text-white w-full justify-between">
              <Button styleType={cta_style_type} style={cta_style} icon="right-arrow-alt" label={`${cta_text}`} reverse={true} link={cta_url || ""} />
            </div>
            )}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseBlock;
